export default __webpack_public_path__ + "static/media/treasure-map.ae95b1c1.png";